import React, { useCallback, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import Button, {
  ButtonSizes,
  ButtonTypes,
} from '@lib/components/Button/Button';

interface Props {
  onFileRead: (content: string) => void;
  disabled?: boolean;
}

export default function ReadFromXmlButton({ onFileRead, disabled }: Props) {
  const { t } = useTranslation();
  const inputRef = useRef<HTMLInputElement>(null);

  const handleClick = useCallback(() => {
    inputRef.current?.click();
  }, []);

  const handleFileChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const file = e.target.files?.[0];
      if (!file) return;

      const reader = new FileReader();
      reader.onload = (event) => {
        const content = event.target?.result;
        if (typeof content === 'string') {
          onFileRead(content);
        }
      };
      reader.readAsText(file);

      // Reset the input so the same file can be selected again
      if (inputRef.current) {
        inputRef.current.value = '';
      }
    },
    [onFileRead],
  );

  return (
    <>
      <input
        ref={inputRef}
        type="file"
        accept=".xml"
        onChange={handleFileChange}
        style={{ display: 'none' }}
      />
      <Button
        buttonText={t('read-from-xml')}
        buttonType={ButtonTypes.primaryOutlined}
        buttonSize={ButtonSizes.small}
        leftIcon="upload_file"
        onClick={handleClick}
        disabled={disabled}
      />
    </>
  );
}
